const TooltipTailUp = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='11' height='8' viewBox='0 0 11 8' fill='none'>
    <path
      d='M6.348 1.3568C5.95633 0.730128 5.04367 0.730129 4.652 1.3568L0.499999 8L10.5 8L6.348 1.3568Z'
      fill='#3D4551'
    />
  </svg>
);

export default TooltipTailUp;
